import { Injectable } from '@angular/core';
import { Router,ActivatedRoute, NavigationEnd } from '@angular/router'

@Injectable({
providedIn: 'root'
})
export class RouterhistoryService {
    urlHistory:Array<string>;
    historySize():number{
        return this.urlHistory.length;
    }


    constructor(private router: Router) { 
        this.urlHistory = new Array<string>();

        router.events.subscribe(
            (routerEvent)=>{
                if(routerEvent instanceof NavigationEnd){
                    this.urlHistory.push(routerEvent.url);
                }
            }
        );


    }
    getPreviousURL(){
        let pos = this.urlHistory.length;
        if(pos <= 1){
            return "";
        }
        return this.urlHistory[pos-2];
    }
}
